import { Entity } from './entity';

export enum UserRole {
  ADMIN = 'admin',
  USER = 'user',
}

export interface User extends Entity {
  mail: string;
  name: string;
  role?: UserRole;
}

export const UserCollection = 'users';
export const UserMailCollection = 'userMails';
